import { companyManufacturerApi } from "@/main/api";
import { KeyValue } from "@/main/models/common";
import { Result } from "@/main/models/common/resultResponse";
import { AxiosResponse, AxiosError } from "axios";
import { saveCompanyManufacturer } from "./companyManufacturerActions";
import { call, put } from "redux-saga/effects";
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";
import { GetCompanyManufacturer } from "./companyManufacturerTypes";

export function* getCompanyManufacturerSaga(action: GetCompanyManufacturer) {
	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(
			companyManufacturerApi.getDomain,
			action.payload.request,
		);

		if (response.data.result) {
			yield put(saveCompanyManufacturer(response.data.result, false, null));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveCompanyManufacturer(null, true, resultError.messagesDataError));
		}
	}
}
